module.exports = __webpack_public_path__ + "img/tips.abce3746.png";